//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SubscribePromoBenefits',
  props: {
    squareIcons: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      promoBenefitsImg: 'https://static.moele.me/img/channels2022/subscription/subscription-promo.png?auto=format&w=522',
    };
  },
};
